export default __webpack_public_path__ + "static/media/zapatos-hombre.52d2d46b.png";